import React from 'react';
import cx from 'classnames';
import {BlockContent} from 'src/components/block-content';

import * as styles from './styled-title.module.css';

export const StyledTitle = ({className, styledTitle}) => {
	return (
		<BlockContent
			className={cx(styles.styledTitle, className)}
			copy={styledTitle}
		/>
	);
};
